import { ProjectActionType, IProjectState, ProjectAction } from "../types/project"

const initialState: IProjectState = {
  projects: [],
  loading: false,
  error: null,
}

export const projectReducer = (
  state: IProjectState = initialState,
  action: ProjectAction
): IProjectState => {
  switch (action.type) {
    case ProjectActionType.FETCH_PROJECTS:
      return { ...state, loading: true }
    case ProjectActionType.FETCH_PROJECTS_SUCCESS:
      return { ...state, projects: action.payload, loading: false }
    case ProjectActionType.FETCH_PROJECTS_ERROR:
      return { ...state, error: action.payload, loading: false }
    default:
      const exhaustiveCheck: never = action
      return state
  }
}

export default projectReducer
